module.exports = __webpack_public_path__ + "img/play.7b571733.svg";